import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  list: [],
  types: [],
  loading: false,
  alarmLoading: false,
  pagination: {},
  paginationAlarms: {},
  current: {},
  fetchingUpdateAlarm: false,
  fetchingAlarmsTypes: false,
  fetchingUpdateAlarmsStatus: false,
  fetchedUpdateAlarmsStatusSuccess: false,
};

const alarmsReducer = createReducer(initialState)({
  // GET ALARMS
  [types.FETCH_ALARMS_REQUEST]: (state) => {
    return {
      ...state,
      list: [],
      loading: true,
    };
  },
  [types.FETCH_ALARMS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      list: payload.data,
      paginationAlarms: payload.pagination,
    };
  },
  [types.FETCH_ALARMS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // GET ALARM BY ID
  [types.FETCH_ALARM_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      list: [],
      alarmLoading: true,
    };
  },
  [types.FETCH_ALARM_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      alarmLoading: false,
      current: payload.data,
    };
  },
  [types.FETCH_ALARM_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      alarmLoading: false,
    };
  },
  // GET ALARMS TYPES
  [types.FETCH_ALARMS_TYPES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAlarmsTypes: true,
    };
  },
  [types.FETCH_ALARMS_TYPES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAlarmsTypes: false,
      types: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_ALARMS_TYPES_FAILED]: (state) => {
    return {
      ...state,
      fetchingAlarmsTypes: false,
    };
  },
  // UPDATE ALARM
  [types.FETCH_UPDATE_ALARM_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateAlarm: true,
    };
  },
  [types.FETCH_UPDATE_ALARM_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      current: payload,
      fetchingUpdateAlarm: false,
    };
  },
  [types.FETCH_UPDATE_ALARM_FAILED]: (state) => {
    return {
      ...state,
      fetchingUpdateAlarm: false,
    };
  },
  // UPDATE ALARMS STATUS (bulk)
  [types.FETCH_UPDATE_ALARMS_STATUS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateAlarmsStatus: true,
      fetchedUpdateAlarmsStatusSuccess: false,
    };
  },
  [types.FETCH_UPDATE_ALARMS_STATUS_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingUpdateAlarmsStatus: false,
      fetchedUpdateAlarmsStatusSuccess: true,
    };
  },
  [types.FETCH_UPDATE_ALARMS_STATUS_FAILED]: (state) => {
    return {
      ...state,
      fetchingUpdateAlarmsStatus: false,
      fetchedUpdateAlarmsStatusSuccess: false,
    };
  },
});

export default alarmsReducer;
